import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Carousel, Skeleton } from "antd";
import { toast } from "react-toastify";

import { getTiers, getTourScreens } from "../../APIs/api";

import "./styles.css";
import Header from "../../components/Header";
import LoyaltyCard from "../../components/LoyaltyCard";
import TourGuide from "../../components/TourGuide";
import { useLocationService } from "../../hooks/useLocationService";
import CustomerServiceInstance from "../../utils/customer-service";
import viewMoreIcon from "../../assets/view-more.svg";

export default function ValiramCard({
  setShowNav,
  stores,
  brands,
  category,
  setBrand,
  setStoreIds,
  setStoreTitle,
  setStores,
  // setStore,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [tourPage, setTourPage] = useState(() =>
    sessionStorage.getItem("tour") === null ? 0 : 6
  );
  const isOnTour = tourPage <= 5;
  const [tourScreens, setTourScreens] = useState([]);
  const [tourScreensLoading, setTourScreensLoading] = useState(false);
  const [isStoreLocater, setIsStoreLocater] = useState(false);
  const [configLoading, setConfigLoading] = useState(false);
  // const dispatch = useDispatch();
  const location = useLocationService();
  const [loading, setLoading] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isScrolled2, setIsScrolled2] = useState(false);

  const handleScroll = (e) => {    
    if (e.target.scrollLeft > 10) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };
  const handleScroll2 = (e) => {    
    if (e.target.scrollLeft > 10) {
      setIsScrolled2(true);
    } else {
      setIsScrolled2(false);
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem("tour") === null) {
      sessionStorage.setItem("tour", true);
    }
    setShowNav(true);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Reset states
    setBrand({});
    setStoreIds([]);
  
    // Fetch data function for tour screens
    const fetchTourScreens = async () => {
      setTourScreensLoading(true);
      try {
        const dataObj = await getTourScreens();
        const dataArray = dataObj?.data?.[0]?.attributes?.data?.data;
        if (dataArray) {
          setTourScreens([...dataArray, ...dataArray]);
        } else {
          setTourPage(6);
        }
      } catch (error) {
        console.error('Error fetching tour screens:', error);
      } finally {
        setTourScreensLoading(false);
      }
    };
  
    // Fetch config function
    const fetchConfig = async () => {
      setConfigLoading(true);
      try {
        const dataObj = await getTiers();
        const dataArray = dataObj?.data?.[0]?.attributes?.data?.abconfig;
        if (dataArray) {
          setIsStoreLocater(dataArray?.is_store_locater);          
        }
      } catch (error) {
        console.error('Error fetching configuration:', error);
      } finally {
        setConfigLoading(false);
      }
    };
  
    // Trigger both fetch functions conditionally
    if (tourPage < 6) {
      fetchTourScreens();
    }
    fetchConfig();
  
    // eslint-disable-next-line
  }, []);

  const groupStoresByBrand = (stores) => {
    return stores.reduce((acc, store) => {
      const brand = store.customFields?.brand;
      const brand_logo = store.customFields?.image_url || null;
      if (brand) {
        const brandImage = brand_logo ? { brand_img: brand_logo } : null;

        if (!acc[brand]) {
          acc[brand] = brandImage ? [brandImage, store] : [store];
        } else {
          if (brandImage) {
            acc[brand].unshift(brandImage);
          }
          acc[brand].push(store);
        }
      }
      return acc;
    }, {});
  };

  useEffect(() => {
    async function getStores() {
      setLoading(true);
      try {
        const data = await CustomerServiceInstance.getNerbyStoresByLocation(
          location
        );
        const groupedStores = groupStoresByBrand(
          data?.storesWithDistance || []
        );
        setStores(groupedStores);
      } catch (e) {
        toast.error(`${e.message}`, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: true,
          closeButton: true,
        });
      } finally {
        setLoading(false);
      }
    }
    if (location?.lat) {
      if (isStoreLocater) {
        getStores();
      }
    }
    // eslint-disable-next-line
  }, [location, isStoreLocater]);

  function getStoreIds(url) {
    const urlParams = new URL(url)?.searchParams;
    const storeIds = urlParams?.get("storeid");
    return storeIds ? storeIds?.split(",") : [];
  }
  const handleStoreClick = (stores, brand) => {
    // console.log(stores,brand);
    if (!stores) {
      const storeIdsArr = getStoreIds(brand?.deeplink);
      setStoreIds(storeIdsArr);           
      navigate("/brands-store-listing", { state: brand?.title });
    } else {
      const storeIds = stores
        .filter((store) => store?.storeId)
        .map((store) => store?.storeId);      
      setStoreIds(storeIds);
      navigate("/brands-store-listing", { state: brand });
    }
  };
  const handleClick = (brand, index) => {
    const params = new URLSearchParams(new URL(brand?.deeplink)?.search);
    const brand_id = params.get("id");    
    navigate("/brand-page/" + brand_id);
  };

  const renderStores = () => {
    const renderStores = isStoreLocater || !Array.isArray(stores) ? Object.keys(stores) : stores;       
    if (!isNaN(Number(renderStores?.[0])) || renderStores.length === 0) {
      return Array.from({ length: 6 }).map((_, index) => (
        <Skeleton.Image
          key={index}
          active={true}
          style={{
            width: 144,
            height: 192,
            borderRadius: "1rem",
          }}
        />
      ));
    }
    if (isStoreLocater) {
      return renderStores.slice(0, 10)?.map((brand, index) => {
        return stores[brand]?.[0]?.brand_img ? (
          <div
            key={index}
            className="card card1 flex items-center justify-center bg-cover bg-top"
            style={{
              backgroundImage: `url(${stores[brand]?.[0]?.brand_img})`,
              backgroundColor: "#B78600",
            }}
            onClick={() => handleStoreClick(stores[brand], brand)}
          ></div>
        ) : (
          <div
            key={index}
            className="card card1 flex items-center justify-center"
            style={{
              backgroundColor: "#B78600",
              width: "144px",
              height: "192px",
              borderRadius: "1rem",
              color: "#fff",
              fontWeight: "bold",
              textAlign: "center",
              padding: "1rem",
            }}
            onClick={() => handleStoreClick(stores[brand], brand)}
          >
            {brand}
          </div>
        );
      });
    } else {
      return renderStores.map((brand, index) => {
        return (
          <div
            key={index}
            className="card card1 flex items-center justify-center bg-cover bg-top"
            style={{
              backgroundImage: `url(${brand.bgImage})`,
              backgroundColor: "#B78600",
            }}
            onClick={() => handleStoreClick(null, brand)}
          ></div>
        );
      });
    }
  };
  return (
    <>
      {!isOnTour ? (
        <>
          <Header
            showLogo
            //  bgColor={"transparent"} textColor={"white"}
          />
          <div className="py-3 h-[90vh] overflow-scroll">
            <div className="px-3 ">
              <LoyaltyCard />
            </div>
            <div className="pt-3 ">
              <div className="flex justify-between text-black">
                <h3 className="playfair text-lg px-3">
                  {t("valiramCard.stores")}
                </h3>
                <div className="pr-3">
                  <img
                    src={viewMoreIcon}
                    alt="view more icon"
                    onClick={() => {
                      setStoreTitle({});
                      setStoreIds([]);
                      navigate("/brands-store-listing");
                    }}
                  />
                </div>
              </div>
              <div className={`carousel-container ${!isScrolled ? 'ml-3' : ''}`} onScroll={handleScroll}>{renderStores()}</div>
            </div>
            <div>
              <div className="flex justify-between text-black">
                <h3 className="playfair text-lg pl-3">
                  {t("valiramCard.brands")}
                </h3>
                <div className="pr-3">
                  <img
                    src={viewMoreIcon}
                    alt="view more icon"
                    onClick={() => navigate("/brands")}
                    className=""
                  />
                </div>
              </div>
              <div className={`carousel-container ${!isScrolled2 ? 'ml-3' : ''}`} onScroll={handleScroll2}>
                {brands?.map((brand, index) => {
                  return brand ? (
                    <div
                      key={index}
                      className="card bg-contain bg-center bg-no-repeat"
                      style={{
                        height: "100px",
                        backgroundImage: `url(${brand.bgImage})`,
                        border: `0.3px solid #000000`,
                        backgroundSize: "cover",
                      }}
                      onClick={() => handleClick(brand, index)}
                    ></div>
                  ) : (
                    <Skeleton.Image
                      active={true}
                      style={{ width: 144, height: 100, borderRadius: "1rem" }}
                    />
                  );
                })}
              </div>
            </div>
            <div className="pb-32">
              <div className="text-black">
                <h3 className="playfair text-lg pl-3">
                  {t("valiramCard.categories")}
                </h3>
              </div>
              {/* <div className="carousel-container"> */}
              <div className="custom-carousal">
                <Carousel autoplay>
                  {category?.map((item, index) => (
                    <div
                      // className="h-32 rounded-2xl text-center pt-4 mt-2 playfair italic text-white text-3xl mb-24 bg-cover"
                      key={index}
                      // className="cardCat bg-cover w-[338px] bg-no-repeat"
                      // style={{
                      //   backgroundImage: `url(${item.bgImage})`,
                      // }}
                      className="px-3"
                      onClick={() => {
                        const url = new URL(item.deeplink);
                        const id = url.searchParams.get("id");
                        sessionStorage.setItem("selectedCat", id);
                        navigate("/brands");
                      }}
                    >
                      <img
                        src={item.bgImage}
                        alt="cat_img"
                        className="w-full h-full object-cover"
                      ></img>
                      {/* {t("valiramCard.food")} */}
                    </div>
                  ))}
                </Carousel>
                {/* </div> */}
              </div>
            </div>
          </div>
        </>
      ) : (
        <TourGuide
          tourPage={tourPage}
          setTourPage={setTourPage}
          tourScreens={tourScreens}
          tourScreensLoading={tourScreensLoading}
        />
      )}
    </>
  );
}
